"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const Icon_1 = __importDefault(require("./Icon"));
function VideoIcon(props) {
    return (react_1.default.createElement(Icon_1.default, Object.assign({}, props),
        react_1.default.createElement("path", { d: "M10.708,7.959a.34.34,0,0,0-.556.263v7.556a.34.34,0,0,0,.556.262L15.3,12.263a.341.341,0,0,0,0-.526Z" }),
        react_1.default.createElement("path", { d: "M19.163,3.958H4.837A2.876,2.876,0,0,0,1.964,6.831V17.169a2.876,2.876,0,0,0,2.873,2.873H19.163a2.876,2.876,0,0,0,2.873-2.873V6.831A2.876,2.876,0,0,0,19.163,3.958ZM20.29,17.169A1.128,1.128,0,0,1,19.163,18.3H4.837A1.128,1.128,0,0,1,3.71,17.169V6.831A1.128,1.128,0,0,1,4.837,5.7H19.163A1.128,1.128,0,0,1,20.29,6.831Z" })));
}
exports.default = VideoIcon;
